import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Report.svg",
  "use": "Report.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"Report.svg\"><path d=\"M32.0208,56.0208a24,24,0,1,1,24-24A24,24,0,0,1,32.0208,56.0208Zm0-44a20,20,0,1,0,20,20A20,20,0,0,0,32.0208,12.0209Zm1.0777,25H30.9492a1.0129,1.0129,0,0,1-1.0211-.9474l-.9146-17a1.01,1.01,0,0,1,1.0208-1.0526h3.9791a1.01,1.01,0,0,1,1.0209,1.0526l-.9147,17A1.013,1.013,0,0,1,33.0985,37.0208Zm-1.0837,3a3,3,0,1,1-3,3A3,3,0,0,1,32.0148,40.0208Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol